import ReactDOM from "react-dom";
import { useState, useEffect, useRef } from 'react';

const Modal = (props) => {
    const modalRef = useRef();
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        modalRef.current = document.getElementById('overlay');
        setMounted(true);
    }, []);

    return (
        <>
            {mounted ? ReactDOM.createPortal(<>{props.children}</>, modalRef.current) : null}
        </>
    )
}

export default Modal;